import React from "react";
import { MsalProvider } from "@azure/msal-react";
import {
  createBrowserRouter,
} from "react-router-dom";
import { getMsalInstance } from "./utils/msalInstance";

import HomePage from "./pages/Home";
import AuthCallbackPage from "./pages/AuthCallback";
import LoginPage from "./pages/Login";
import FormAuthoringPage from "./pages/FormAuthoring";
import FormFillingPage from "./pages/FormFilling";
import ViewAuthoringPage from "./pages/ViewAuthoring";
import ErrorBoundary from "./pages/ErrorBoundary";

import "@/styles/globals.css";
import ViewFormPage from "./pages/ViewForm";
import AppWrapper from "./AppWrapper";

export default createBrowserRouter([
  {
    errorElement: <ErrorBoundary />,
    element: (
      <MsalProvider instance={getMsalInstance()!}>
        <AppWrapper />
      </MsalProvider>
    ),
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/auth-callback",
        element: <AuthCallbackPage />,
      },
      {
        path: "/form-authoring",
        element: <FormAuthoringPage />,
      },
      {
        path: "/form-filling",
        element: <FormFillingPage />,
      },
      {
        path: "/view-authoring",
        element: <ViewAuthoringPage />,
      },
      {
        path: "/view-form",
        element: <ViewFormPage />
      }
    ],
  },
]);
